import { gql, TypedDocumentNode } from '@common/hooks';
import {
  UpdateEnabledRolesForSupplierMutationCgResponse,
  UpdateEnabledRolesForSupplierMutationVariables,
} from '@common/graphql/schema';

export const UpdateEnabledRolesForSupplierMutation: TypedDocumentNode<
  UpdateEnabledRolesForSupplierMutationCgResponse,
  UpdateEnabledRolesForSupplierMutationVariables
> = gql`
  mutation UpdateEnabledRolesForSupplier($supplierId: ID!, $roleIds: [ID!]!) {
    updateEnabledRolesForSupplier(supplierId: $supplierId, roleIds: $roleIds) {
      roles {
        id
        name
        abbreviation
        roleType
        enabledForSupplier(supplierId: $supplierId)
      }
    }
  }
`;
